import { AutoSizer } from 'react-virtualized';
import Text from '../../../atoms/Text';
import CompetitionTrades from './Table';

const Competitions = () => {
  return (
    <div className='dex_trades'>
      <div className='dex_trades__options'>
        <div className='dex_trades__options__item dex_trades__options__item--active'>
          <Text size={14} className='text--weight-400'>
            Trades
          </Text>
        </div>
      </div>
      <div className='dex_trades__separator' />
      <AutoSizer style={{ width: '100%', height: '100%' }}>
        {({ width }) => <CompetitionTrades width={width} />}
      </AutoSizer>
    </div>
  );
};

export default Competitions;
